import * as types from "./types";

export const addFlashCardTopicRequest = (payload) => ({
  type: types.ADD_FLASH_CARD_TOPIC_REQUEST,
  payload
});

export const addFlashCardTopicResponse = (payload) => ({
  type: types.ADD_FLASH_CARD_TOPIC_RESPONSE,
  payload
});

export const getAllFlashCardTopicsRequest = (payload) => ({
  type: types.GET_ALL_FLASH_CARD_TOPICS_REQUEST,
  payload
});

export const getAllFlashCardTopicsResponse = (payload) => ({
  type: types.GET_ALL_FLASH_CARD_TOPICS_RESPONSE,
  payload
});

export const editFlashCardTopicRequest = (payload) => ({
  type: types.EDIT_FLASH_CARD_TOPIC_REQUEST,
  payload
});

export const editFlashCardTopicResponse = (payload) => ({
  type: types.EDIT_FLASH_CARD_TOPIC_RESPONSE,
  payload
});

export const deleteFlashCardTopicRequest = (payload) => ({
  type: types.DELETE_FLASH_CARD_TOPIC_REQUEST,
  payload
});

export const deleteFlashCardTopicResponse = (payload) => ({
  type: types.DELETE_FLASH_CARD_TOPIC_RESPONSE,
  payload
});

export const getSingleFlashCardTopicRequest = (payload) => ({
  type: types.GET_SINGLE_FLASH_CARD_TOPIC_REQUEST,
  payload
});

export const getSingleFlashCardTopicResponse = (payload) => ({
  type: types.GET_SINGLE_FLASH_CARD_TOPIC_RESPONSE,
  payload
});

// sub-topics

export const getAllFlashCardSubTopicsRequest = (payload) => ({
  type: types.GET_ALL_FLASH_CARD_SUB_TOPICS_REQUEST,
  payload
});

export const getAllFlashCardSubTopicsResponse = (payload) => ({
  type: types.GET_ALL_FLASH_CARD_SUB_TOPICS_RESPONSE,
  payload
});

export const addFlashCardSubTopicRequest = (payload) => ({
  type: types.ADD_FLASH_CARD_SUB_TOPIC_REQUEST,
  payload
});

export const addFlashCardSubTopicResponse = (payload) => ({
  type: types.ADD_FLASH_CARD_SUB_TOPIC_RESPONSE,
  payload
});
export const getSingleFlashCardSubTopicRequest = (payload) => ({
  type: types.GET_SINGLE_FLASH_CARD_SUB_TOPIC_REQUEST,
  payload
});

export const getSingleFlashCardSubTopicResponse = (payload) => ({
  type: types.GET_SINGLE_FLASH_CARD_SUB_TOPIC_RESPONSE,
  payload
});

export const editFlashCardSubTopicRequest = (payload) => ({
  type: types.EDIT_FLASH_CARD_SUB_TOPIC_REQUEST,
  payload
});

export const editFlashCardSubTopicResponse = (payload) => ({
  type: types.EDIT_FLASH_CARD_SUB_TOPIC_RESPONSE,
  payload
});

export const deleteFlashCardSubTopicRequest = (payload) => ({
  type: types.DELETE_FLASH_CARD_SUB_TOPIC_REQUEST,
  payload
});

export const deleteFlashCardSubTopicResponse = (payload) => ({
  type: types.DELETE_FLASH_CARD_SUB_TOPIC_RESPONSE,
  payload
});
